import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setStep, setCourse } from '../../../../../../redux/slices/courseSlice';
import { useForm } from 'react-hook-form';
import { BsPlusCircleDotted } from 'react-icons/bs';
import SubmitButtons from '../SubmitButtons';
import CourseSection from './CourseSection';
import { toast } from 'react-hot-toast';

const CourseBuilder = () => {
  const dispatch = useDispatch();
  const { course } = useSelector(state => state.course);
  const {
    register,
    setValue,
    getValues,
    reset,
    formState: { errors }
  } = useForm();

  const submitHandler = () => {
    if (!course.length) {
      toast.error('Create at least one section.', { duration: 3000 });
      return;
    }
    if (course.some((element) => !element[Object.keys(element)[0]].length)) {
      toast.error('Create at least one lecture in each section.', { duration: 3000 });
      return;
    }
    dispatch(setStep(3));
  };

  const resetHandler = () => {
    dispatch(setCourse([]));
  };
  const backHandler = () => {
    dispatch(setStep(1));
  };

  const onCreateSectionHandler = () => {
    dispatch(setCourse([...course, { [getValues('sectionName')]: [] }]));
    setValue('sectionName', '');
  };

  return (
    <div>
      <header className='text-2xl font-semibold'>Build Your Course</header>
      <form className='w-full flex flex-col md:gap-y-7 gap-y-5'>
        <div className='p-7 my-3 border border-dashed border-richblack-300 rounded-lg'>
          <div>
            <label className='w-full'>
              <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>
                Create Section <sup className='text-pink-200'>*</sup>
              </p>
              <input
                className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                type='text'
                id='sectionName'
                placeholder='Enter Section Name'
                {...register('sectionName')}
              />
            </label>
          </div>
          <div>
            <button
              className='p-2 border rounded-lg mt-4 border-yellow-50 flex justify-center items-center gap-x-2 text-yellow-50 font-semibold hover:scale-95 transition-all duration-200'
              type='button'
              onClick={() => getValues('sectionName').trim() !== '' && onCreateSectionHandler()}
            >
              Create Section
              <BsPlusCircleDotted className='text-xl' />
            </button>
          </div>
        </div>
        <div>
          {course.length > 0 && (
            <div className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 flex flex-col gap-2'>
              {course.map((section, index) => (
                <div key={index}>
                  <CourseSection
                    section={section}
                    register={register}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    reset={reset}
                    sectionIndex={index}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <SubmitButtons
            submitText='Next'
            resetText='Reset'
            cancelText='Back'
            submitType='button'
            resetType='reset'
            submitHandler={submitHandler}
            resetHandler={resetHandler}
            cancelHandler={backHandler}
          />
        </div>
      </form>
    </div>
  );
};

export default CourseBuilder;